"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINConversation = exports.PINChatDateIndicator = exports.PINChatBubblePlaceholder = exports.PINChatBubbleAction = exports.PINChatBubble = void 0;
var react_1 = __importDefault(require("react"));
var moment = __importStar(require("moment"));
var simples_1 = require("../simples");
var model_1 = require("../../model");
var react_linkify_1 = __importDefault(require("react-linkify"));
var Linkify = react_linkify_1.default;
var react_2 = require("@iconify/react");
var utilities_1 = require("../../utilities");
/**
 * Create a stylized div element indicating a date.
 * @param {Date} date The date of the message to come.
 * @param {function} t The translation function.
 * @param {any} [momentInstance] A customized or configured Moment instance. By
 * default, it uses the Kit moment instance.
 * @param {string} [className] A class name to use on the wrapping div element.
 */
var PINChatDateIndicator = function (_a) {
    var date = _a.date, t = _a.t, _b = _a.momentInstance, momentInstance = _b === void 0 ? moment : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    var momentDate = momentInstance(date);
    var prefix = "";
    if (momentInstance().isSame(momentDate, "day")) {
        prefix = t("modelKit.date.today") + ", ";
    }
    else if (momentInstance().subtract(1, "day")
        .isSame(momentDate, "day")) {
        prefix = t("modelKit.date.yesterday") + ", ";
    }
    return (react_1.default.createElement("div", { className: className + " pinchat-date-indicator" }, "" + prefix + momentInstance(date).format("LL")));
};
exports.PINChatDateIndicator = PINChatDateIndicator;
/**
 * @description Main ChatBubble. Drived by [[PINMessageData]]
 * @param props Props. See [[PINChatBubbleProps]]
 */
var PINChatBubble = function (_a) {
    var message = _a.message, _b = _a.onClick, onClick = _b === void 0 ? function (_message) { return null; } : _b, _c = _a.name, name = _c === void 0 ? null : _c, _d = _a.errorAction, errorAction = _d === void 0 ? function (_text) { return null; } : _d, t = _a.t;
    return (react_1.default.createElement("div", { className: "chat-bubble-container " + message.sender },
        react_1.default.createElement("div", { className: "chat-bubble", onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(message); } },
            react_1.default.createElement(Linkify, { properties: { target: "_blank", rel: "noopener noreferrer" } }, message.text)),
        react_1.default.createElement("div", { className: "bottom typo fs12 color-moon mt-xs" },
            message.state === model_1.PINMessageState.Sending
                && react_1.default.createElement("span", null, t(message.formattedStateKey())),
            message.state === model_1.PINMessageState.Error && (react_1.default.createElement(simples_1.PINButton, { color: simples_1.PINButtonStyle.failure, className: "align-items-center no-outline", inline: true, small: true, onClick: function () { return errorAction(message.text); } },
                react_1.default.createElement(react_2.Icon, { icon: "mdi:alert", style: { fontSize: "1.6rem" }, color: utilities_1.Colors.failure, className: "mr-xs" }),
                t(message.formattedStateKey()))),
            message.state === model_1.PINMessageState.Sent
                && react_1.default.createElement("span", null, moment.unix(message.received).format("kk:mm")),
            name && react_1.default.createElement("span", null, " - " + name))));
};
exports.PINChatBubble = PINChatBubble;
/**
 * @description Action message. Display an icon and a text, and listen to onClick events.
 * @param props See [[PINChatBubbleActionProps]]
 */
var PINChatBubbleAction = function (_a) {
    var sender = _a.sender, text = _a.text, iconProps = _a.iconProps, actionText = _a.actionText, _b = _a.onClick, onClick = _b === void 0 ? function () { return null; } : _b;
    return (react_1.default.createElement("div", { className: "chat-bubble-container " + sender },
        react_1.default.createElement("div", { className: "chat-bubble pointer action-bubble", onClick: onClick },
            react_1.default.createElement("div", { className: "action-frame d-flex align-items-center justify-content-center lg-radius background-white full-width mb-sm" },
                react_1.default.createElement("div", { className: "d-flex flex-column align-items-center pv-sm" },
                    react_1.default.createElement(react_2.Icon, __assign({}, iconProps)),
                    react_1.default.createElement("span", { className: "typo semibold fs14", style: { color: iconProps.color } }, actionText))),
            react_1.default.createElement("span", { className: "mh-md" }, text))));
};
exports.PINChatBubbleAction = PINChatBubbleAction;
/**
 * @description A simple BubblePlaceholder, with a .shimmer-background
 * @param props See [[PINChatBubblePlaceholderProps]]
 */
var PINChatBubblePlaceholder = function (_a) {
    var sender = _a.sender;
    return (react_1.default.createElement("div", { className: "chat-bubble-container " + sender },
        react_1.default.createElement("div", { className: "chat-bubble shimmer-background bubble-placeholder" })));
};
exports.PINChatBubblePlaceholder = PINChatBubblePlaceholder;
/**
 * Return a full conversation in form of a list of {@link PINChatBubble}.
 * Section every message per day, by adding a {@link PINChatDateIndicator}.
 *
 * @param {PINMessageData[]} messages The messages to display.
 * @param {string} senderName The name used for describe the sender.
 * @param {string} leadName The name used to describe the lead.
 * @param {function} t The translation function.
 * @param {any} [momentInstance] A customized or configured Moment instance. By
 * default, it uses the Kit moment instance.
 * @param {function} [errorAction] A click handler for error state messages.
 * @param {function} [onClick] A click handler for non-error state messages.
 * @param {string} [className] A class name to use on the wrapping div element.
 */
var PINConversation = function (_a) {
    var messages = _a.messages, senderName = _a.senderName, leadName = _a.leadName, t = _a.t, _b = _a.momentInstance, momentInstance = _b === void 0 ? moment : _b, _c = _a.errorAction, errorAction = _c === void 0 ? function () { return null; } : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { return null; } : _d, _e = _a.className, className = _e === void 0 ? "" : _e;
    var elements = [];
    var lastReceived = null;
    messages.forEach(function (message, index) {
        var messageMoment = message.received
            ? momentInstance(message.received * 1000)
            : momentInstance();
        var shouldAddDateIndicator = (lastReceived != null && !messageMoment.isSame(lastReceived * 1000, "day")) || index === 0;
        if (shouldAddDateIndicator) {
            elements.push(react_1.default.createElement(PINChatDateIndicator, { key: index + "-cdi", t: t, date: messageMoment.toDate(), momentInstance: momentInstance }));
        }
        lastReceived = messageMoment.unix();
        elements.push(react_1.default.createElement(PINChatBubble, { key: index, t: t, message: message, errorAction: errorAction, onClick: onClick, name: message.sender === model_1.PINMessageSender.Lead ? leadName : senderName }));
    });
    return (react_1.default.createElement("div", { className: className + " pinconversation" }, elements));
};
exports.PINConversation = PINConversation;
//# sourceMappingURL=PINChatBubbles.js.map